import { render, staticRenderFns } from "./FlagForm.vue?vue&type=template&id=64b692b5&scoped=true&"
import script from "./FlagForm.vue?vue&type=script&lang=js&"
export * from "./FlagForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b692b5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64b692b5')) {
      api.createRecord('64b692b5', component.options)
    } else {
      api.reload('64b692b5', component.options)
    }
    module.hot.accept("./FlagForm.vue?vue&type=template&id=64b692b5&scoped=true&", function () {
      api.rerender('64b692b5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Finance/FlagForm.vue"
export default component.exports